module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921131149_T.6acdf026.jpg";